import { Chip, SxProps, Theme } from '@mui/material';
import { baseColors } from 'utils/constants';

type Props = {
  sx?: SxProps<Theme> | undefined;
};

const OptionalChip = ({ sx }: Props) => (
  <Chip
    label="任意"
    size="small"
    sx={{
      p: 0,
      bgcolor: baseColors.lineGray,
      color: baseColors.white,
      fontSize: '14px',
      fontWeight: 'normal',
      borderRadius: 1,
      ...sx
    }}
  />
);

export default OptionalChip;
